import api from '../api';

export const PROCUREMENT_FEATURES = ['lots', 'suppliers', 'lot_analytics', 'supplier_analytics', 'possible_suppliers', 'search_alerts'] as const;
export type ProcurementFeature = typeof PROCUREMENT_FEATURES[number];
export interface ProcurementPlanConfig {
  features: Record<ProcurementFeature, boolean>;
  max_active_searches: number;
  channels: ('site' | 'telegram')[];
}

export interface ProcurementAdminSettings {
  lots_enabled: boolean; suppliers_enabled: boolean; search_alerts_enabled: boolean;
  check_interval_minutes: number; max_searches_per_run: number; max_lots_per_search: number;
  max_notifications_per_run: number; max_stored_searches_per_user: number;
  default_procurement: ProcurementPlanConfig;
}
export interface ProcurementSettingsResponse { settings: ProcurementAdminSettings; revision: number; feature_keys: ProcurementFeature[]; channels: string[] }
export interface ProcurementAccessSummary {
  features: Record<ProcurementFeature, boolean>; max_active_searches: number | null;
  channels: string[]; sources: { kind: string; id?: string; expires_at?: string | null }[];
}
export interface ProcurementAdminUser { id: string; email: string; name: string; surname: string; access: ProcurementAccessSummary }
export interface ProcurementGrant {
  id: string; user_id: string; procurement: ProcurementPlanConfig; expires_at: string | null;
  reason: string; created_at: string; revoked_at: string | null; revision: number;
}

export async function getProcurementAdminSettings() {
  return (await api.get<ProcurementSettingsResponse>('/admin/procurement/settings')).data;
}

export interface SearchAlertsWorkerStatus {
  enabled: boolean; check_interval_minutes: number;
  last_started_at: string | null; last_finished_at: string | null; next_due_at: string | null;
  journal_epoch: string | null; committed_event_batch: number; journal_pending_batch: number | null;
  last_event_at: string | null; last_source_success_at: string | null;
  event_age_seconds: number | null; source_age_seconds: number | null;
  pending_candidates: number | null; awaiting_source: number | null;
  outbox_pending: number | null; outbox_retrying: number | null; outbox_uncertain: number | null;
  last_result: { searches: number; notifications: number; errors: number; last_error?: { stage: string; code: string } | null } | null;
  last_error: { stage: string; code: string } | null; partial: boolean;
}

export async function getSearchAlertsWorkerStatus(signal?: AbortSignal): Promise<SearchAlertsWorkerStatus> {
  return (await api.get('/admin/procurement/search-alerts/status', { signal })).data;
}
